import React from "react";
import { Avatar, Box, Skeleton } from "@mui/material";
import PlayCircleOutlineRoundedIcon from "@mui/icons-material/PlayCircleOutlineRounded";
import PauseCircleOutlineRoundedIcon from "@mui/icons-material/PauseCircleOutlineRounded";
import GraphicEqRoundedIcon from "@mui/icons-material/GraphicEqRounded";
import { useTheme } from "@emotion/react";
import { Link } from "react-router-dom";

import defaltImg from "../../../media/svg/Avatar/Avatar5.svg";

const CustomAvatar = ({
  link,
  size,
  round,
  borderSize,
  borderColor,
  src,
  iconSize,
  iconType,
  alt,
  pinAvatar,
  overlay,
}) => {
  const theme = useTheme();
  return (
    <Link to={link ? link : null}>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {iconType && (
          <>
            {iconType === "voice" && (
              <GraphicEqRoundedIcon
                sx={{
                  width: iconSize ? iconSize : 24,
                  height: iconSize ? iconSize : 24,
                  position: "absolute",
                  zIndex: 3,
                  color: "white.main",
                }}
              />
            )}
            {iconType === "video" && (
              <PlayCircleOutlineRoundedIcon
                sx={{
                  width: iconSize ? iconSize : 24,
                  height: iconSize ? iconSize : 24,
                  position: "absolute",
                  zIndex: 3,
                  color: "white.main",
                }}
              />
            )}
            {iconType === "pause" && (
              <PauseCircleOutlineRoundedIcon
                sx={{
                  width: iconSize ? iconSize : 24,
                  height: iconSize ? iconSize : 24,
                  position: "absolute",
                  zIndex: 3,
                  color: "white.main",
                }}
              />
            )}
            {!overlay && (
              <Box
                sx={{
                  position: "absolute",
                  backgroundColor: "black.main",
                  opacity: 0.4,
                  width: size,
                  height: size,
                  borderRadius: round ? round : "50%",
                  zIndex: 2,
                }}
              ></Box>
            )}{" "}
          </>
        )}

        {!src ? (
          <>
            {src === undefined ? (
              <Skeleton
                sx={{ borderRadius: round ? round : "50%" }}
                variant='circular'
                width={size ? size : 20}
                height={size ? size : 20}
              />
            ) : (
              <Avatar
                alt={alt ? alt : "avatar"}
                src={defaltImg}
                sx={{
                  mx: "2px",
                  my: "4px",
                  width: size ? size : 20,
                  height: size ? size : 20,
                  borderRadius: round ? round : "50%",
                  backgroundColor: "black",
                  boxShadow: `0px 0px 0px ${borderSize ? borderSize : "2"}px ${
                    borderColor ? borderColor : theme.palette.black.main
                  }`,
                }}
              />
            )}
          </>
        ) : (
          <Avatar
            alt={alt ? alt : "avatar"}
            src={src}
            sx={{
              mx: "2px",
              my: "4px",
              width: size ? size : 20,
              height: size ? size : 20,
              borderRadius: round ? round : "50%",
              backgroundColor: "black",
              boxShadow: `0px 0px 0px ${borderSize ? borderSize : "2"}px ${
                borderColor ? borderColor : theme.palette.black.main
              }`,
              opacity: overlay ? 0.7 : 1,
              zIndex: 1,
              pointerEvents: "none",
            }}
          />
        )}
        {pinAvatar && (
          <>
            <Box
              sx={{
                height: "28px",
                borderRight: "2px solid",
                borderColor: "#BDBDBD",
                position: "absolute",
                left: "20px",
                top: "40px",
              }}
            ></Box>
            <Box
              sx={{
                height: "56px",
                borderRight: "2px dashed",
                borderColor: "#BDBDBD",
                position: "absolute",
                left: "20px",
                top: "70px",
              }}
            ></Box>
            <Box sx={{ position: "absolute", top: "82px", left: "6px" }}>
              <Avatar
                alt={alt ? alt : "avatar"}
                src={src}
                sx={{
                  mx: "2px",
                  my: "4px",
                  width: 26,
                  height: 26,
                  borderRadius: "50%",
                  backgroundColor: "black",
                  boxShadow: `0px 0px 0px ${borderSize ? borderSize : "2"}px ${
                    borderColor ? borderColor : theme.palette.black.main
                  }`,
                }}
              />
            </Box>
          </>
        )}
      </Box>
    </Link>
  );
};
export default CustomAvatar;
